module.exports = {"371625001":"城东街道","371625002":"锦秋街道","371625003":"博昌街道","371625101":"曹王镇","371625102":"兴福镇","371625103":"陈户镇","371625104":"湖滨镇","371625106":"店子镇","371625107":"吕艺镇","371625108":"纯化镇","371625109":"庞家镇","371625110":"乔庄镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371625.json
// module id = 1617
// module chunks = 0